"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../../../targets/cord_eurofh_teams/config.js"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../../../KESI2/KESI2BasicComponent"));

var _KesiConstants = require("../../../../../KESI2/KesiConstants");

var _DataStore = _interopRequireWildcard(require("../../../../../KESI2/Stores/DataStore2"));

var _RegisterInstance = _interopRequireDefault(require("../../../../../KESI2/Services/RegisterInstance"));

var _QdNugget = _interopRequireDefault(require("../../../../../KESI2/entities/nuggets/QdNugget"));

var _Quiz = _interopRequireDefault(require("../../../Equizzer/Quiz"));

var _QuizHomeStyle = require("../../../Equizzer/styles/QuizHomeStyle");

var _ThemeStore = _interopRequireDefault(require("../../../ThemeStore/ThemeStore"));

var _DrupalQdMultiplayerNugget = _interopRequireDefault(require("./DrupalQdMultiplayerNugget.scss"));

var _QuizModeChooser = require("../../../Equizzer/QuizModeChooser");

var _UserService = _interopRequireDefault(require("../../../Equizzer/services/UserService"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var DOM_PREFIX = 'qdContainer_';

var DrupalQdMultiplayerNugget = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(DrupalQdMultiplayerNugget, _Kesi2BasicComponent);

  var _super = _createSuper(DrupalQdMultiplayerNugget);

  function DrupalQdMultiplayerNugget(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, DrupalQdMultiplayerNugget);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getGroupData", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var groupId, token;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_MODE, _QuizModeChooser.QUIZ_PLAYMODES.BATTLE);

            case 2:
              groupId = _this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_ID];

              if (!groupId) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return _RegisterInstance["default"].getAccessToken('quizUser:read');

            case 6:
              token = _context.sent;
              _context.next = 9;
              return _UserService["default"].getAllUsersAndLoadTheme(groupId, 'Bearer ' + token);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDomId", function () {
      return "".concat(DOM_PREFIX).concat(_this.props.id);
    });
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getAuthToken", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var tokenPart;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _RegisterInstance["default"].getAccessToken('quizGame:read quizGame:write quizUser:read quizUser:write quizGroup:read');

            case 2:
              tokenPart = _context2.sent;
              return _context2.abrupt("return", "Bearer ".concat(tokenPart));

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    _this.state = _objectSpread({
      // TODO: remove?
      waitingForActivation: false,
      selectedCategory: '',
      categoryList: [],
      waitingForQuestions: false,
      questionList: [],
      question: null,
      questionIndex: -1
    }, _this.state); // the nugget will be put there on a magic way by Reflux and props.id which is given in the constructor

    _this.active = true;

    _this.props.registerNugget(_this.props.id, _QdNugget["default"].CLASS, _this.getDomId(), _this.props.inSwipeContainer || _this.props.inGalleryContainer || _this.props.inListContainer);

    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(DrupalQdMultiplayerNugget.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES, _DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_GROUP_ID, _DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID, _DataStore.DATA_STORE_PATHS.QD_SELECTED_CATEGORY]);
    return _this;
  }

  (0, _createClass2["default"])(DrupalQdMultiplayerNugget, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.registerNuggetPosition(this.props.id, _QdNugget["default"].CLASS, this.getDomId());

      var userSubject = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);

      var userSubjectsAvail = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER_SUBJECTS);

      if (!userSubject && userSubjectsAvail.length > 0) {
        _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID, userSubjectsAvail[0].id);

        _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_MODE, _QuizModeChooser.QUIZ_PLAYMODES.BATTLE);
      }

      this.getGroupData();

      if (this.props.inListContainer) {
        this.props.setBackButtonFunc(this.props.goUpFunc);
      }
    }
  }, {
    key: "componentDidUpdate",

    /*
    componentWillUpdate (newProps, newState) {
      console.log('DrupalQdNugget.componentWillUpdate', newProps, newState)
      const nugget = newState.content[this.props.id]
       const active = DataStore.pathExists(`${this.props.id}.${this.props.contentPathArray.join(KESI_PATH_DELIMITER)}`, newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES])
        ? newState.data[DATA_STORE_PATHS.KESI_VISIBILITIES][this.props.id][this.props.contentPathArray.join(KESI_PATH_DELIMITER)]
        : nugget.active
       if (newState.waitingForActivation && active !== this.active) {
        newState['waitingForActivation'] = false
      }
    }
    */
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(DrupalQdMultiplayerNugget.prototype), "componentDidUpdate", this).call(this, prevProps, prevState, snapshot);
      var nugget = this.state.content[prevProps.id];
      var active = _DataStore["default"].pathExists("".concat(prevProps.id, ".").concat(prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)), this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES]) ? this.state.data[_DataStore.DATA_STORE_PATHS.KESI_VISIBILITIES][prevProps.id][prevProps.contentPathArray.join(_KesiConstants.KESI_PATH_DELIMITER)] : nugget.active;

      if (this.state.waitingForActivation && active !== this.active) {
        this.setState({
          waitingForActivation: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var styles = (0, _QuizHomeStyle.getStyles)(this.state);
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.listStyle,
        className: _DrupalQdMultiplayerNugget["default"].qdNuggetDiv
      }, /*#__PURE__*/_react["default"].createElement(_Quiz["default"], (0, _extends2["default"])({}, this.props, {
        runsInKesi: true,
        getAuthToken: function getAuthToken() {
          return _this2.getAuthToken();
        }
      })));
    }
  }]);
  return DrupalQdMultiplayerNugget;
}(_KESI2BasicComponent["default"]);

DrupalQdMultiplayerNugget.propTypes = {
  id: _propTypes["default"].string.isRequired,
  path: _propTypes["default"].string,
  registerNugget: _propTypes["default"].func.isRequired,
  markAsRead: _propTypes["default"].func.isRequired,
  contentPathArray: _propTypes["default"].array.isRequired,
  inSwipeContainer: _propTypes["default"].bool.isRequired,
  inListContainer: _propTypes["default"].bool.isRequired,
  inGalleryContainer: _propTypes["default"].bool.isRequired,
  setTitle: _propTypes["default"].func.isRequired,
  goUpFunc: _propTypes["default"].func
};
DrupalQdMultiplayerNugget.defaultProps = {
  id: null
};
var _default = DrupalQdMultiplayerNugget;
exports["default"] = _default;